import { render } from "./UAEDownload.vue?vue&type=template&id=2cceaba7"
import script from "./UAEDownload.vue?vue&type=script&lang=js"
export * from "./UAEDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__